import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ModalComponent } from 'ngx-boot-modal';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css']
})
export class ConfirmModalComponent {
  @Input() title: string;
  @Input() message: string;
  @Input() messageParams = {};
  @Input() confirmLabel = 'shared.confirm.confirm';
  @Input() cancelLabel = 'shared.confirm.cancel';
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @ViewChild(ModalComponent) modal: ModalComponent;

  open() {
    this.modal.open();
  }

  onCancel() {
    this.modal.close();
    this.cancel.emit();
  }

  onConfirm() {
    this.modal.close();
    this.confirm.emit();
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/components/modals/confirm-modal/confirm-modal.component.ts